import React from "react";
import CustomerGroupSettingsEdit from "../components/customers/CustomerGroupSettingsEdit";
import TitleUpdater from "../components/common/layout/TitleUpdater";

export default function CustomerGroupSettingsPage() {

  return (
    <div>
      <TitleUpdater />
      <CustomerGroupSettingsEdit />
    </div>
  );
}
